/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_Theme_HintInputs */

const cs_settings_prefs_theme_hint = /** @type {(inputs: Settings_Prefs_Theme_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uloží se k vašemu účtu a synchronizuje se mezi zařízeními.`)
};

const en_settings_prefs_theme_hint = /** @type {(inputs: Settings_Prefs_Theme_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved to your account and synced across devices.`)
};

/**
* | output |
* | --- |
* | "Saved to your account and synced across devices." |
*
* @param {Settings_Prefs_Theme_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_theme_hint = /** @type {((inputs?: Settings_Prefs_Theme_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_Theme_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_theme_hint(inputs)
	return cs_settings_prefs_theme_hint(inputs)
});